import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ResourcesItem } from 'redux-and-the-rest';

import useQuery from '../../hooks/useQuery';
import { UserModel } from '../../models/userModel';
import { clearUser, getUser, destroyUserSession } from '../../redux/reducers/userReducer';
import { ApplicationState } from '../../redux/types';
import { getRedirectToUrl, isExternalRoute } from '../../utils/Routes';
import LoadingIndicator from '../shared/LoadingIndicator';
import Env from '../../utils/env';
import { clearCookie } from '../../utils/AuthCookie';

const { LOGOUT_DESTINATION_URL } = Env;

interface Props {
  user: ResourcesItem<UserModel>
}

const LogoutScreen = ({ user }: Props): React.ReactElement => {
  // Pick up and apply any required redirect on Logout
  const queryParams = useQuery();

  useEffect(() => {
    destroyUserSession();
    clearUser();
    clearCookie();
  }, []);

  if (Object.keys(user.values).length === 0) {
    const redirectToParam = queryParams.get('redirectTo');
    const redirectUrl = getRedirectToUrl(LOGOUT_DESTINATION_URL, redirectToParam);

    if (isExternalRoute(redirectUrl)) {
      window.location.href = redirectUrl;
    }

    return <Redirect to={redirectUrl} />;
  }

  return <LoadingIndicator />;
};

const mapStateToProps = ({ users }: ApplicationState) => ({
  user: getUser(users),
});

export default connect(mapStateToProps)(LogoutScreen);
